<div class="row" [formGroup]="group">
	<div class="col-xl-12">
		<div class="m-form__section m-form__section--first">
			<div class="m-form__heading">
				<h3 class="m-form__heading-title">
					Declaration:
				</h3> 
			</div>
			<div class="form-group m-form__group row">
				<label class="col-xl-3 col-lg-3 col-form-label">
					Declaration Undertaking:
				</label>
				<div class="col-xl-8 col-lg-8">
					<div class="declaration-content">
						<p class="declaration-para">
							I hereby declare that the information submitted by me is correct and true to the best of my knowledge.
							<br> I shall be liable for any disciplinary/punitive action in case any of the details are found to be incorrect.

						</p>
					</div>
				</div>

			</div>
			<!-- <div class="form-group m-form__group row">
				<label class="col-form-label col-lg-3 col-sm-12">
					Captcha Verification:
				</label>
				<re-captcha class="g-recaptcha" (resolved)="catchGoogleRecaptchaRespone($event)"></re-captcha>
				<script src="https://www.google.com/recaptcha/api.js" async defer></script>
			</div> -->

		</div>
	</div>
</div>
